var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-page"},[_c('ButtonBack',{attrs:{"routeBack":_vm.routeBack}}),_c('Lesson')],1)}
var staticRenderFns = []

export { render, staticRenderFns }